import React from 'react'
import Organizations from "../../Organizations/Organizations"

const Organizationsdiv = () => {
  return (
    <div>
      <Organizations/>
    </div>
  )
}

export default Organizationsdiv
